import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/browser';
import * as serviceWorker from './serviceWorker';
import LogRocket from 'logrocket';

require('es6-promise').polyfill()

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({dsn: "https://e4145441fc9c45e5b16ba75abd6a42fb@sentry.io/1500735"});

  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra("sessionURL", sessionURL);
    })
  })

  LogRocket.init('bogkwv/summit-form');
}


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
